import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { PaymentAdvanceData } from '@/features/paymentAdvances/types/paymentAdvance.type'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

export type CreatePaymentAdvanceParams = {
  bill_id: string
  requested_total: number
  date_to_be_paid: string
}

interface UseCreatePaymentAdvanceProps {
  onSuccess?: (response: AxiosResponse<{ data: PaymentAdvanceData }>) => void
  onError?: (error: ErrorResponse) => void
}

export const useCreatePaymentAdvance = ({ onSuccess, onError }: UseCreatePaymentAdvanceProps = {}) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createPaymentAdvance'],
    mutationFn: async (params: CreatePaymentAdvanceParams) => {
      const { bill_id, requested_total, date_to_be_paid } = params

      return privateAxios.post('/billing/payment_advances', {
        payment_advance: {
          bill_id,
          requested_total: Number(requested_total),
          date_to_be_paid,
        },
      })
    },
    onSuccess,
    onError,
  })
}
